import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

// One selectable row inside a listbox-style dropdown menu (role="option").
// Content is free-form children (status dots, labels, count pills); the atom
// owns the button element, its selection semantics, and the hover/selected
// backgrounds. The consumer's wrapping element should carry role="listbox".
const StyledButton = styledComponent('button', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  padding: '8px 10px',
  background: 'none',
  border: 'none',
  borderRadius: theme.radii.input,
  cursor: 'pointer',
  fontSize: theme.sizes.smallFontSize,
  color: theme.colors.textBody,
  textAlign: 'left',

  '&:hover': {
    background: theme.colors.bgMuted,
  },
  '&.selected': {
    background: theme.colors.bgMuted,
    fontWeight: theme.fontWeights.semibold,
  },
});

function ListOption({ children, onClick, selected, dataTestId }) {
  return (
    <StyledButton
      type="button"
      role="option"
      className={selected ? 'selected' : ''}
      aria-selected={selected}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </StyledButton>
  );
}

ListOption.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  dataTestId: PropTypes.string,
};

ListOption.defaultProps = {
  selected: false,
  dataTestId: undefined,
};

export default ListOption;
